import React from 'react'
import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectCurrentAccessToken, selectCurrentScope } from "./authSlice"

const AdminRequired = () => {
    const accessToken = useSelector(selectCurrentAccessToken)
    const scope = useSelector(selectCurrentScope)
    const location = useLocation()
    sessionStorage.setItem('lastActivePage', location.pathname);

    return (
        accessToken && scope === 'PORTAL_SUPER_ADMIN'
            ? <Outlet />
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}

export default AdminRequired